import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import onClickOutside from 'react-onclickoutside';

import SocialNetworkIcon from 'components/common/SocialNetworkIcon';
import InputField from 'components/elements/InputField';
import { fixURL } from 'utils/fixURL';

import './LinkURL.css';


const ENTER_KEY = 13;

class LinkURL extends Component {
  static propTypes = {
    patchLink: PropTypes.func.isRequired,
    linkUrl: PropTypes.string.isRequired,
    linkId: PropTypes.number.isRequired,
    linkError: PropTypes.object,
  };
  static defaultProps = {
    linkError: null,
  };

  state = {
    selectedLinkId: null,
    initialValue: '',
    currentValue: '',
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.linkUrl) {
      this.setState({
        initialValue: this.props.linkUrl,
        currentValue: this.props.linkUrl,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  _changeUrl = () => {
    const _currentValue = fixURL(this.state.currentValue);

    if (this.state.currentValue !== '') {
      this.setState({
        selectedLinkId: null,
        initialValue: _currentValue,
      });
      this.props.patchLink(
        this.props.linkId,
        { url: _currentValue },
      );
    }


  };

  handleClickOutside = () => {
    const { initialValue, currentValue } = this.state;
    if (currentValue !== initialValue) {
      this._changeUrl();
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      if (this.props.linkId === this.state.selectedLinkId) {
        this._changeUrl();
      }
    }
  };

  render() {
    let errorData = null;
    if (this.state.currentValue === '') {
      errorData = {
        id: `link_url_id_${this.props.linkId}`,
        text: 'Link cannot be empty'
      }
    }
    else if(
      this.props.linkError && this.props.linkError.url &&
      parseInt(this.props.linkError.url.link_id) === this.props.linkId
    ) {
      errorData = {
        id: `link_url_id_${parseInt(this.props.linkError.url.link_id)}`,
        text: this.props.linkError.url.error
      }
    }

    return (
      <div className="link-url__component">
        <div className="icon-container">
          <SocialNetworkIcon
            link
            url={this.state.currentValue}
          />
        </div>

        <InputField
          hoverable
          value={this.state.currentValue}
          id={this.props.linkId}
          onChange={(e) => {
            e.preventDefault();
            this.setState({
              selectedLinkId: this.props.linkId,
              currentValue: e.target.value,
            });
          }}
          error={errorData}
        />
      </div>
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(onClickOutside(LinkURL));
